import React, { useState, useEffect } from "react";
import BMWLogo from "../../assets/images/BMWLogo.png";
import Car from "../../assets/images/LoadCar.png";
// import Rectangle from "../../assets/images/Rectangle.png";

const LoadingScreen = () => {
  const [windowSize, setWindowSize] = useState({
    width: typeof window !== 'undefined' ? window.innerWidth : 0,
    height: typeof window !== 'undefined' ? window.innerHeight : 0
  });

  // Handle window resize
  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    };

    window.addEventListener('resize', handleResize);

    // Call handler right away so state gets updated with initial window size
    handleResize();

    // Remove event listener on cleanup
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Get responsive car width based on screen size
  const getCarWidth = () => {
    // Check for iPhone 14 Pro Max and similar large phones
    if (windowSize.width >= 400 && windowSize.width <= 450 && windowSize.height >= 900) {
      return '600px';
    }
    // Check for smaller screens (iPhone SE and similar)
    if (windowSize.width <= 400) {
      return '515px';
    }
    return '515px'; // Default for all other screens
  };

  return (
    <div
      className="flex flex-col items-center justify-center h-screen w-full 
  bg-gradient-to-b from-[#010e2a] via-[#163c5b] to-[#5ba9dc] 
  relative overflow-hidden 
  px-16 sm:px-8 md:px-16 lg:px-24 xl:px-32 
  py-4 sm:py-8 md:py-16"
    >
      <div className="relative w-full max-w-[100%] h-[74vh] sm:min-h-[80vh] flex flex-col items-center px-4 sm:px-8 overflow-hidden">
        {/* Background Image */}
        {/* <img
          src={Rectangle}
          alt="Background"
          className="absolute inset-0 w-full h-full  z-0"
        /> */}

        {/* BMW Logo */}
        <div className="flex flex-col items-center justify-start w-full pt-[2rem] sm:pt-12 relative z-10">
          <img
            src={BMWLogo}
            alt="BMW Logo"
            className="w-16 h-16 sm:w-20 sm:h-20 md:w-24 md:h-24 lg:w-28 lg:h-28 object-contain mb-8 sm:mb-12 md:mb-16 lg:mb-20 xl:mb-24"
          />
          <div
            className="flex flex-col items-center 
             space-y-3 sm:space-y-4 md:space-y-6 lg:space-y-8"
          >
            <h2
              className="text-white 
               text-lg sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl 
               font-bmw font-light tracking-wide"
            >
              Loading
            </h2>

            <div className="relative">
              <div className="w-10 h-10 sm:w-12 sm:h-12 md:w-16 md:h-16 lg:w-20 lg:h-20 xl:w-24 xl:h-24">
                <svg
                  className="animate-spin w-full h-full text-white"
                  viewBox="0 0 50 50"
                >
                  <circle
                    className="opacity-20"
                    cx="25"
                    cy="25"
                    r="16"
                    stroke="currentColor"
                    strokeWidth="5"
                    fill="none"
                  />
                  <circle
                    className="opacity-100"
                    cx="25"
                    cy="25"
                    r="16"
                    stroke="currentColor"
                    strokeWidth="5"
                    strokeLinecap="round"
                    strokeDasharray="50 125"
                    fill="none"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="absolute 
    bottom-[14vh] sm:bottom-[14vh] md:bottom-[15vh] lg:bottom-[16vh] 
    left-[74%] md:left-1/2 -translate-x-1/2 
    z-20"
      >
        <img
          src={Car}
          alt="BMW Car"
          className="
      object-contain h-auto
      sm:w-[420px] md:w-[500px] lg:w-[540px] xl:w-[560px]
      max-w-[560px]
    "
          style={{
            width: getCarWidth()
          }}
        />
      </div>
    </div>
  );
};

export default LoadingScreen;
